// Internationalization Import
import i18n from "i18next";

// Internal Imports
import ArtikelFilter from "./ArtikelFilter";
import { ArtikelColumns } from "./ArtikelColumns";
import { IArtikel } from "../../../Models/IArtikel";
import { IArtikelFilter } from "../../../Models/IArtikelFilter";
import ArtikelDetailsPanel from "./ArtikelDetailsPanel";
import React, { useState, useEffect } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import {
  IosArrowRtl24Regular,
  ShoppingBagAddRegular,
} from "@fluentui/react-icons";
import { Button, MessageBar, Subtitle1 } from "@fluentui/react-components";
import LuebPagedDataGrid from "../../../Controls/LuebPagedDataGrid";
import Header from "../../Layout/Header";
import useWindowSize from "../../../helpers/useWindowSize";
import HeaderTextAnimation from "../../Layout/HeaderTextAnimation";

// Props
interface IArtikelProps {}

// Function

function Artikel(props: IArtikelProps) {
  const windowSize = useWindowSize();
  const [parts, setParts] = useState<IArtikel[]>([]);

  const [artikelFilterObj, setArtikelFilterObj] = useState<IArtikelFilter>({
    artikelId: "",
    benennung: "",
    sachGruppeGuid: "",
    artikelGruppeGuid: "",
  });

  const [artikelPanelOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  const handleArtikelValuesChange = (name: string, val: string | IArtikel) => {
    setArtikelValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
  };

  const [artikelValues, setArtikelValues] = useState({
    item: {
      artikelId: "",
      benennungDE: "",
      benennungEN: "",
      sachgruppe: "",
      artikel: { benennungDE: "", benennungEN: "" },
    },
  });

  const columns = ArtikelColumns({
    searchParamArtikelId: artikelFilterObj.artikelId,
    searchParamBenennung: artikelFilterObj.benennung,
  });

  let lang: string;
  if (i18n.language.includes("de")) {
    lang = "de";
  } else {
    lang = "en";
  }

  let benennung = "";

  if (artikelValues.item.artikel) {
    if (lang == "de") {
      benennung = artikelValues.item.artikel.benennungDE;
    } else {
      benennung = artikelValues.item.artikel.benennungEN;
    }
  } else {
    if (lang == "de") {
      benennung = artikelValues.item.benennungDE;
    } else {
      benennung = artikelValues.item.benennungEN;
    }
  }

  useEffect(() => {
    if (columns.clickedArtikel) {
      handleArtikelValuesChange("item", columns.clickedArtikel);
    } else {
      dismissPanel();
    }
  }, [columns.clickedArtikel]);

  return (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            {(windowSize.width > 1250 ||
              windowSize.width < 1024 ||
              !columns.clickedArtikel) && (
              <Button
                icon={<ShoppingBagAddRegular fontSize={24} color="#ff6600" />}
                size="large"
                appearance="subtle"
                onClick={() => {
                  columns.resetArtikel();
                }}
              >
                {i18n.t<string>("parts").toLocaleUpperCase()}
              </Button>
            )}
            {windowSize.width < 1251 &&
              windowSize.width > 1024 &&
              columns.clickedArtikel && (
                <Button
                  style={{ paddingLeft: "0px" }}
                  size="small"
                  onClick={() => {
                    columns.resetArtikel();
                  }}
                  appearance="transparent"
                >
                  <ShoppingBagAddRegular fontSize={24} color="#ff6600" />
                </Button>
              )}

            {columns.clickedArtikel && (
              <>
                <IosArrowRtl24Regular color="#ff6600" />
                <Button appearance="transparent">
                  <HeaderTextAnimation
                    text={
                      i18n.language.includes("de") &&
                      columns.clickedArtikel.benennungDE
                        ? columns.clickedArtikel.benennungDE
                        : columns.clickedArtikel.benennungEN
                        ? columns.clickedArtikel.benennungEN
                        : ""
                    }
                  />
                </Button>
              </>
            )}
          </StackShim>
        }
      />

      {!columns.clickedArtikel && (
        <>
          <ArtikelFilter
            onFilterValuesChange={(filterValues: IArtikelFilter) => {
              setArtikelFilterObj(filterValues);
            }}
            onSearchResult={(data: any) => {
              setParts(data);
            }}
            onSearchStarted={() => {}}
          />
          <div className="lueb-ContentBlock">
            <LuebPagedDataGrid
              columns={columns.getColumns()}
              items={parts}
              resizableColumns={true}
              columnSizingOptions={{
                artikelId: { defaultWidth: 120, minWidth: 100 },
                benennungId: { defaultWidth: 420, minWidth: 350 },
                artikelgruppeId: { defaultWidth: 200, minWidth: 200 },
                sachgruppeId: { defaultWidth: 200, minWidth: 200 },
              }}
            />
            {parts.length < 1 && (
              <MessageBar intent="info">
                {i18n.t<string>("noItemsFound")}
              </MessageBar>
            )}
          </div>
        </>
      )}

      {columns.clickedArtikel && (
        <ArtikelDetailsPanel
          isPivot={true}
          artikelId={
            columns.clickedArtikel.artikelId
              ? columns.clickedArtikel.artikelId
              : ""
          }
          benennungDE={
            columns.clickedArtikel.benennungDE
              ? columns.clickedArtikel.benennungDE
              : ""
          }
          benennungEN={
            columns.clickedArtikel.benennungEN
              ? columns.clickedArtikel.benennungEN
              : ""
          }
        />
      )}
    </div>
  );
}

// Export Function
export default Artikel;
